<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li>

          <a class="link-effect" [routerLink]="['/solicitudes-engie']" *ngIf="parentComponent=='solicitudes'">Mis
            Solicitudes</a>
          <a class="link-effect" [routerLink]="['/solicitudes', 'aprobacion']" *ngIf="parentComponent=='aprobacion'">Mis
            Solicitudes</a>
          <a class="link-effect" [routerLink]="['/solicitudes', 'administracion']" *ngIf="parentComponent=='administracion'">Mis
            Solicitudes - Administrador</a>
          <a class="link-effect" [routerLink]="['/solicitudes-contratista']" *ngIf="parentComponent=='contratista'">Mis
            Solicitudes</a>
        </li>
        <li><span class="link-effect">Detalle de Solicitud</span></li>
      </ol>
    </div>
  </div>
</div>

<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Detalle de Solicitud</h3>
    </div>
  </div>

  <div class="block-content">
    <app-solicitud-master-progress [model]="model" [data]="model" [flujoCompleto]="model.aplicaPersonas"></app-solicitud-master-progress>
    <app-solicitud-master-edit-header [model]="model" [data]="model"
      [disabled]="model.idSolicitudPrevia != null || model.idEstado == 6 || model.idEstado == 10 || model.idEstado == 11 || ( !esSolicitante && model.idEstado != 6)"></app-solicitud-master-edit-header>

  </div>

  <div class="block-content">
    <div class="form-horizontal">
      <mat-divider class="engie-divider"></mat-divider>
    </div>
    <mat-accordion class="seccion-solicitud" multi>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Personal
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-horizontal" *ngIf="model.idSolicitudPrevia">
          <div class="form-group">
            <div class="col-sm-6 text-left">
              <mat-slide-toggle [ngModel]="model.aplicaPersonas" class="aplica" disabled="disabled">
                <span *ngIf="model.aplicaPersonas">SI REQUIERE PERSONAS</span><span *ngIf="!model.aplicaPersonas">NO
                  REQUIERE PERSONAS</span>
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <table mat-table #tablePersonal [dataSource]="model.personas" class="table table-striped table-vcenter">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Trabajador</th>
              <td mat-cell *matCellDef="let element">
                {{
                element.nombres +
                " " +
                element.apellidoPaterno +
                " " +
                element.apellidoMaterno
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="dni">
              <th mat-header-cell *matHeaderCellDef>Documento de Identidad</th>
              <td mat-cell *matCellDef="let element" class="centre">{{ element.nroDocumentoIdentidad }}</td>
            </ng-container>

            <ng-container matColumnDef="cargo">
              <th mat-header-cell *matHeaderCellDef>Cargo</th>
              <td mat-cell *matCellDef="let element">{{ element.cargo }}</td>
            </ng-container>

            <ng-container matColumnDef="cantidad_documentos">
              <th mat-header-cell *matHeaderCellDef>
                Cantidad de documentos
              </th>
              <td mat-cell *matCellDef="let element" class="centre">
                {{ element.documentos.length }}
              </td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>acciones</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogPersonal(element)">
                  <mat-icon>search</mat-icon>
                </button>

                <button mat-icon-button color="primary" aria-label="Eliminar"
                  *ngIf="estadosBorrarRegistrosEngie.includes(model.idEstado) && idTipoUsuario == 1"
                  (click)="deletePersona(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsPersonal">
            </tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsPersonal">
            </tr>
          </table>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Equipos
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-6 text-left">
              <mat-slide-toggle [ngModel]="model.aplicaEquipos" class="aplica" disabled="disabled">
                <span *ngIf="model.aplicaEquipos">SI REQUIERE EQUIPOS</span><span *ngIf="!model.aplicaEquipos">NO
                  REQUIERE EQUIPOS</span>
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="model.aplicaEquipos">
          <table mat-table #tableEquipos [dataSource]="model.equipos" class="table table-striped table-vcenter">
            <!-- <ng-container matColumnDef="equipo">
                        <th mat-header-cell *matHeaderCellDef>Equipo</th>
                        <td mat-cell *matCellDef="let element">{{ element.tipo }}</td>
                      </ng-container> -->

            <ng-container matColumnDef="marca">
              <th mat-header-cell *matHeaderCellDef>Marca</th>
              <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
            </ng-container>

            <ng-container matColumnDef="modelo">
              <th mat-header-cell *matHeaderCellDef>Modelo</th>
              <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
            </ng-container>

            <ng-container matColumnDef="serie">
              <th mat-header-cell *matHeaderCellDef>Serie</th>
              <td mat-cell *matCellDef="let element" class="centre">{{ element.serie }}</td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogEquipo(element)">
                  <mat-icon>search</mat-icon>
                </button>

                <button mat-icon-button color="primary" aria-label="Eliminar"
                  *ngIf="estadosBorrarRegistrosEngie.includes(model.idEstado) && idTipoUsuario == 1"
                  (click)="deleteEquipo(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsEquipos"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsEquipos"></tr>
          </table>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Vehículos
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-6 text-left">
              <mat-slide-toggle [ngModel]="model.aplicaVehiculos" class="aplica" disabled="disabled">
                <span *ngIf="model.aplicaVehiculos">SI REQUIERE VEHÍCULOS</span><span *ngIf="!model.aplicaVehiculos">NO
                  REQUIERE VEHÍCULOS</span>
              </mat-slide-toggle>
            </div>
          </div>
        </div>
        <div class="table-responsive" *ngIf="model.aplicaVehiculos">
          <table mat-table #tableVehiculos [dataSource]="model.vehiculos" class="table table-striped table-vcenter">
            <ng-container matColumnDef="marca">
              <th mat-header-cell *matHeaderCellDef>Marca</th>
              <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
            </ng-container>

            <ng-container matColumnDef="modelo">
              <th mat-header-cell *matHeaderCellDef>Modelo</th>
              <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
            </ng-container>

            <ng-container matColumnDef="placa">
              <th mat-header-cell *matHeaderCellDef>Placa</th>
              <td mat-cell *matCellDef="let element">{{ element.placa }}</td>
            </ng-container>

            <ng-container matColumnDef="color">
              <th mat-header-cell *matHeaderCellDef>Color</th>
              <td mat-cell *matCellDef="let element">{{ element.color }}</td>
            </ng-container>

            <ng-container matColumnDef="anio">
              <th mat-header-cell *matHeaderCellDef>Año</th>
              <td mat-cell *matCellDef="let element">{{ element.anio }}</td>
            </ng-container>

            <ng-container matColumnDef="chofer">
              <th mat-header-cell *matHeaderCellDef>Chofer</th>
              <td mat-cell *matCellDef="let element">
                {{
                element.solicitudChofer.nombres +
                " " +
                element.solicitudChofer.apellidoPaterno +
                " " +
                element.solicitudChofer.apellidoMaterno
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element" class="centre">{{ element.estado }}</td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element">
                <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogVehiculo(element)">
                  <mat-icon>search</mat-icon>
                </button>
                <button mat-icon-button color="primary" aria-label="Eliminar"
                  *ngIf="estadosBorrarRegistrosEngie.includes(model.idEstado) && idTipoUsuario == 1"
                  (click)="deleteVehiculo(element)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculos"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculos"></tr>
          </table>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Documentación Técnica
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-sm-6 text-left">
              <mat-slide-toggle [ngModel]="model.aplicaDocumentacionTecnica" class="aplica" disabled="disabled">
                <span *ngIf="model.aplicaDocumentacionTecnica">SI REQUIERE DOCUMENTACIÓN TÉCNICA</span><span
                  *ngIf="!model.aplicaDocumentacionTecnica">NO REQUIERE DOCUMENTACIÓN TÉCNICA</span>
              </mat-slide-toggle>
            </div>
          </div>
          <div class="table-responsive" *ngIf="model.aplicaDocumentacionTecnica">
            <table mat-table #tableDocumentacionTecnica [dataSource]="model.documentosTecnicos"
              class="table table-striped table-vcenter">
              <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef>Nombre</th>
                <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
              </ng-container>

              <ng-container matColumnDef="idRequisito">
                <th mat-header-cell *matHeaderCellDef>Requisito</th>
                <td mat-cell *matCellDef="let element" class="centre">{{ element.requisito }}</td>
              </ng-container>

              <ng-container matColumnDef="fechaVencimiento">
                <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
                <td mat-cell *matCellDef="let element" class="centre">
                  {{ element.fechaVencimiento | date: "dd/MM/yyyy"}}
                </td>
              </ng-container>

              <ng-container matColumnDef="idDocumento">
                <th mat-header-cell *matHeaderCellDef>Doc.</th>
                <td mat-cell *matCellDef="let element">
                  <a *ngIf="element.fileIsDeleted">Eliminado por Usuario</a>
                  <a *ngIf="!element.fileIsDeleted"
                    (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
                </td>
              </ng-container>
              <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="primary" aria-label="Eliminar"
                    *ngIf="estadosBorrarRegistrosEngie.includes(model.idEstado) && idTipoUsuario == 1 && element.nombreArchivo!=''"
                    (click)="deleteDocTecnico(element)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsDocumentacionTecnica"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsDocumentacionTecnica"></tr>
            </table>
          </div>
          <div class="form-group" *ngIf="model.logsDocumentacionTecnica.length > 0">
            <label class="col-md-1 control-label">Historial Comentarios:</label>
            <div class="col-md-4">
              <app-log-dialog-anchor [logs]="model.logsDocumentacionTecnica"></app-log-dialog-anchor>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="block-content">
    <mat-divider class="engie-divider"></mat-divider>
  </div>

  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group" *ngIf="model.logs.length > 0">
        <label class="col-md-1 control-label">Historial Comentarios Solicitud:</label>
        <div class="col-md-4">
          <app-log-dialog-anchor [logs]="model.logs"></app-log-dialog-anchor>
        </div>
      </div>
    </div>
  </div>
  <div class="block-content">
    <mat-divider class="engie-divider"></mat-divider>
  </div>
  <div class="block-content">
    <div class="form-horizontal pad-25">
      <div class="form-group">
        <div class="col-sm-12 text-right">

          <a class="btn btn-celeste" mat-raised-button [disabled]="!EsValidoParaEnviar()"
            *ngIf="(model.idSolicitudPrevia == null && esSolicitante && model.idEstado != 6 && model.idEstado != 10 && model.idEstado != 11) || model.puedeCambiarSolicitante" (click)="guardarHeader()"><mat-icon>save</mat-icon> Guardar</a>
            <a class="btn btn-naranja" mat-raised-button 
            *ngIf="esSolicitante && (model.idEstado == 8 || model.idEstado == 9 || model.idEstado == 10)" (click)="adicionarinfo()"><mat-icon>playlist_add</mat-icon> Adicionar Información</a>
          <a class="btn btn-naranja2" mat-raised-button (click)="back()"><mat-icon>exit_to_app</mat-icon> Salir</a>
        </div>
      </div>
    </div>
  </div>
</div>